import React, { Component } from 'react'
import { Editor, EditorState, convertFromRaw, convertToRaw } from 'draft-js'

import './OfflineEditor.css'

class OfflineEditor extends Component {
  constructor() {
    super()

    let editorState = null
    let rawContent = window.localStorage.getItem('rawContent')
    
    if (rawContent) {
      const content = convertFromRaw(JSON.parse(rawContent))
      editorState = EditorState.createWithContent(content)
    } else {
      editorState = EditorState.createEmpty()
    }
    
    this.state = { editorState }
  }
  
  componentDidMount() {
    this.domEditorRef.focus()
  }
  
  setDomEditorRef = (ref) => {
    this.domEditorRef = ref
  }
  
  onChange = (editorState) => {
    this.setState({ editorState })
    
    const rawContent = convertToRaw(editorState.getCurrentContent())
    window.localStorage.setItem('rawContent', JSON.stringify(rawContent))
  }
  
  render() {
    return (
      <div className="OfflineEditor-container">
        <h1>You are now offline.</h1>
        <Editor
          editorState={this.state.editorState}
          onChange={this.onChange}
          ref={this.setDomEditorRef}
        />
      </div>
    )
  }
}

export default OfflineEditor



// WEBPACK FOOTER //
// ./src/OfflineEditor.js